import { Container } from '@mui/material';

import { AppPage } from '@/shared/components';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import UserManagement from '@/features/UserManagement';

const OrganizationSettingsPage = () => {
  const title = 'Organization Settings';

  useDocumentTitle(title);

  return (
    <AppPage title={title} requiredPermissions={['menu:manage:org']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        {/* UserManagement renders the PageHeader so the Invite User button can
            sit in its action slot — the handler that opens the invite dialog
            lives in useUserManagement, which is not reachable from here. */}
        <UserManagement
          title={title}
          subtitle="Manage your organization settings, including user management and organization members"
        />
      </Container>
    </AppPage>
  );
};

export default OrganizationSettingsPage;
